<li class="listSmartButtonMore">
  <a [style.width.px]="buttonWidth" href="#" (click)="$event.preventDefault()" (click)="onSmartButtonClick()">
    <i *ngIf="iconClass" [ngClass]="[iconClass]"></i> {{ label | textLimit: buttonWidth / 7 }}</a
  >
</li>
